<template>
  <div class="modal-card" :class="{ 'contains-dropdown': containsDropdown }">
    <div class="modal-card-head">
      <div class="modal-card-title">{{ title }}</div>

      <div>
        <slot name="head-right"></slot>
      </div>
    </div>

    <slot name="body">
      <div class="modal-card-body">
        <slot></slot>
      </div>
    </slot>

    <div class="modal-card-foot">
      <slot name="foot">
        <button class="button" @click="$parent.$parent.close()">Close</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },

    containsDropdown: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.modal-card.contains-dropdown,
.modal-card.contains-dropdown .modal-card-body {
  overflow: initial;
}
.modal-content,
.modal-card {
  overflow: initial !important;
}
</style>
